import { Asset, AssetState } from '@/api/generatedApi';
import { StyledList, StyledListItem } from '@/components/AssetsPage/PopoverList';
import { useDownloadAsset } from '@/hooks/useDownloadAsset';
import { useGetAsset } from '@/hooks/api/assets/useGetAsset';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { Download as DownloadIcon } from '@mui/icons-material';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import LabelIcon from '@mui/icons-material/Label';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Divider, ListItemIcon, ListItemText } from '@mui/material';

export const AssetActionsMenuContent = ({
  asset,
  onClose,
  onMoveClick,
  onLabelClick,
  onReplaceFileClick,
  sx,
}: {
  asset: Asset;
  onClose: () => void;
  onMoveClick: (asset: Asset) => void;
  onLabelClick?: (asset: Asset) => void;
  onReplaceFileClick?: (asset: Asset) => void;
  sx?: object;
}) => {
  const { permissions } = useGetCurrentUser();
  const { downloadAsset } = useDownloadAsset();
  const { asset: cachedAsset } = useGetAsset({ assetId: asset.id, enabled: false });
  const currentState = cachedAsset?.state ?? asset.state;

  const handleDownloadClick = async () => {
    onClose();
    await downloadAsset(asset);
  };

  const handleMoveClick = () => {
    onMoveClick(asset);
    onClose();
  };

  const handleLabelClick = () => {
    onLabelClick?.(asset);
    onClose();
  };

  const handleReplaceFileClick = () => {
    onReplaceFileClick?.(asset);
    onClose();
  };

  return (
    <StyledList sx={sx}>
      <Divider />
      <StyledListItem onClick={() => void handleDownloadClick()}>
        <ListItemIcon>
          <DownloadIcon sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText>Download</ListItemText>
      </StyledListItem>
      {permissions.canCreateFolders && (
        <StyledListItem onClick={handleMoveClick}>
          <ListItemIcon>
            <DriveFileMoveIcon sx={{ fontSize: '18px' }} />
          </ListItemIcon>
          <ListItemText>Move Asset</ListItemText>
        </StyledListItem>
      )}
      {permissions.canUploadAssets && onReplaceFileClick && currentState !== AssetState.Indexing && (
        <StyledListItem onClick={handleReplaceFileClick}>
          <ListItemIcon>
            <UploadFileIcon sx={{ fontSize: '18px' }} />
          </ListItemIcon>
          <ListItemText>Replace File</ListItemText>
        </StyledListItem>
      )}
      {onLabelClick && (
        <StyledListItem onClick={handleLabelClick}>
          <ListItemIcon>
            <LabelIcon sx={{ fontSize: '18px' }} />
          </ListItemIcon>
          <ListItemText>Label</ListItemText>
        </StyledListItem>
      )}
    </StyledList>
  );
};
